

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _angular = require('angular');

require('./lib/ui');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _squid = require('squid');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('xo-models/src/shoppingcart/index');

var _index2 = require('xo-models/src/ppcartMapper/index');

var _index3 = require('xo-models/src/cartButtonParams/index');

var _index4 = require('xo-models/src/inventory/index');

require('xo-ui-components/src/accessibility/directive');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _cartUtil = require('./cartUtil');

var _cartUtil2 = _interopRequireDefault(_cartUtil);

var _cartUiUtil = require('./cartUiUtil');

var _cartUiUtil2 = _interopRequireDefault(_cartUiUtil);

var _shippingUtil = require('./shippingUtil');

var _shippingUtil2 = _interopRequireDefault(_shippingUtil);

var _customUtil = require('../../js/lib/customUtil.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var sCart = void 0,
    buttonParams = void 0,
    cartItems = void 0,
    cartRequest = void 0,
    checkoutCartDetails = void 0,
    soldoutItems = void 0,
    additionalCharges = void 0,
    checkoutXclickParam = void 0,
    merchantAccNumber = void 0,
    profileShippingError = void 0;
var setAdditionalParameters = void 0,
    calculateShippingCharges = void 0,
    getShoppingCart = void 0,
    callUpdateCart = void 0,
    callDeleteCart = void 0,
    initiateUpdateQuantity = void 0,
    itemsToUpdate = void 0,
    fallback = void 0,
    prepareCheckout = void 0,
    consumeMid = void 0;
var memberXOButtonScript = void 0,
    guestXOButtonScript = void 0;
var addressErrorData = void 0,
    addressError = void 0;
var genericErrorCases = ['INTERNAL_SERVICE_ERROR', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_HOSTED_BUTTON_ID', 'INVALID_INPUT', 'ITEM_PRICE_MISSING', 'NO_ADD_OR_DISPLAY'];

exports['default'] = _squid.$Component.extend('$xoShoppingCart', {
    tag: 'xo-shopping-cart-page',
    template: _template2['default'],

    resolve: {
        models: function models() {
            var _this = this;

            if (this.stateChanged) {
                return;
            }

            // TODO: replace this hard coded token with the mayfly Id that will be coming in the url
            var shoppingCartModel = _index.$ShoppingCartModel.instance(_squid.$meta.correlationId);
            var buttonParamsModel = _index3.$CartButtonParamsModel.instance();
            var noUpdateRequired = _uiRouter.$state.params.noUpdateRequired;

            if (!buttonParams) {
                return _uiRouter.$state.go('checkout.error.genericError');
            }
            var buttonType = buttonParams.buttonType;
            var buttonDetails = {};
            if (buttonParams) {
                if (buttonParams.buttonItem && buttonParams.buttonItem.items[0] && buttonParams.buttonItem.items[0].customized_info) {
                    buttonDetails.hosted_button_id = buttonParams.buttonItem.items[0].customized_info.hosted_button_id;
                }
            }
            buttonDetails['button_type'] = buttonType;
            _logger.$logger.info('button_details', buttonDetails);
            setAdditionalParameters = function setAdditionalParameters(shoppingCart) {
                sCart = $.extend(true, {}, shoppingCart);
                if (shoppingCart) {
                    _this.itemsInCart = $.extend(true, [], shoppingCart.items);
                    cartItems = $.extend(true, [], shoppingCart.items);
                    if (shoppingCart.items && shoppingCart.items[0]) {
                        _this.currencyCode = shoppingCart.items && shoppingCart.items[0].currency;
                    }
                }
                _this.continueShoppingUrl = shoppingCart && shoppingCart.urls && shoppingCart.urls.shopping_url || _this.previousPageUrl;
                var additionalChargesRes = _cartUtil2['default'].validateAndGetAdditionalCharges(sCart);
                if (additionalChargesRes && additionalChargesRes.cartValid) {
                    additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
                    _this.additionalCharges = $.extend(true, {}, additionalChargesRes.charges);
                } else {
                    _logger.$logger.info('cart_invalid', additionalChargesRes);
                    _this.stateChanged = true;
                    return _uiRouter.$state.go('checkout.error.genericError');
                }
                _logger.$logger.info('additional_parameters', {
                    continue_shopping_url: _this.continueShoppingUrl,
                    additional_charges: additionalCharges
                });
                if (cartItems) {
                    var itemsDetails = cartItems.map(function (item) {
                        return {
                            sku: item.sku,
                            name: item.name
                        };
                    });
                    _logger.$logger.info('items_details', itemsDetails);
                }
                _this.cartTotalZero = _cartUtil2['default'].areAllItemsZeroPriced(_this.itemsInCart) && _this.getNetTotal() === 0;
            };

            var createShoppingCart = function createShoppingCart(itemFromButton, payeeEmail, visitorId) {
                var createCartItem = JSON.parse(JSON.stringify(itemFromButton));
                if (!createCartItem.total_weight && createCartItem.items && createCartItem.items[0] && createCartItem.items[0].weight) {
                    createCartItem.total_weight = {
                        'value': '',
                        'unit': createCartItem.items[0].weight.unit
                    };
                }
                return shoppingCartModel.action('createShoppingCart', {
                    data: {
                        request: createCartItem
                    },
                    success: function success(result) {
                        _this.visitorId = result.visitor_id;
                        setAdditionalParameters(result);
                    },
                    contingencies: {
                        DUPLICATE_REQUEST: function DUPLICATE_REQUEST(err) {
                            _logger.$logger.info('DUPLICATE_REQUEST_error', err);
                            _this.duplicateRequest = true;
                            _this.payeeEmail = payeeEmail;
                            _this.visitorId = visitorId;
                        }
                    }
                }).then(function () {
                    return calculateShippingCharges();
                });
            };

            getShoppingCart = function getShoppingCart() {
                shoppingCartModel.invalidate();
                return shoppingCartModel.retrieve({
                    params: {
                        payee_email: _this.payeeEmail,
                        visitor_id: _this.visitorId
                    },
                    success: function success(response) {
                        sCart = $.extend(true, {}, response);
                        _this.itemsInCart = $.extend(true, [], response.items);
                        cartItems = $.extend(true, [], response.items);
                        _this.currencyCode = response.items && response.items[0] && response.items[0].currency;
                        _this.continueShoppingUrl = response.urls && response.urls.shopping_url || _this.previousPageUrl;
                        setAdditionalParameters(response);
                    }
                }).then(function () {
                    return calculateShippingCharges();
                });
            };

            consumeMid = function consumeMid() {
                return buttonParamsModel.action('consumeMid', {
                    data: {
                        mid: _squid.$util.param('mid'),
                        mfid: _squid.$util.param('mfid')
                    },
                    success: function success(result) {
                        _logger.$logger.info('updated mid ' + _squid.$util.param('mid') + ' as consumed');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(err) {
                            _logger.$logger.info('consume mid err, ', err);
                        }
                    }
                });
            };

            calculateShippingCharges = function calculateShippingCharges() {
                if (!merchantAccNumber) {
                    _logger.$logger.info('skip shipping charges call, unilateral merchant cannot have profile shipping');
                    return;
                }
                // Service gives validation error in the case where shipping calculation require address(for US merchants)
                if (profileShippingError) {
                    _logger.$logger.info('skip shipping charges call, calculation error');
                    return;
                }
                var items = _cartUtil2['default'].getItemsForShippingCalculation(cartItems, additionalCharges);
                var noShippingParam = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams)['no_shipping'];
                return _shippingUtil2['default'].getShippingCharges(buttonParams.merchantId, items, noShippingParam).then(function (shippingResponse) {
                    if (shippingResponse.profileShippingError) {
                        profileShippingError = true;
                        if (sCart) {
                            delete sCart.shippingProfile;
                        }
                        return;
                    }
                    sCart.shippingProfile = shippingResponse;
                    setAdditionalParameters(sCart);
                });
            };

            callUpdateCart = function callUpdateCart(shoppingCart) {
                if (!_this.cartStateChanged) {
                    _angular.$timeout.cancel(_this.timer);
                    return;
                }
                _this.cartStateChanged = false;
                var itemFromButton = buttonParams.buttonItem;
                if (itemFromButton && !itemFromButton.total_weight && !shoppingCart.total_weight && itemFromButton.items && itemFromButton.items[0] && itemFromButton.items[0].weight) {
                    if (shoppingCart.items && shoppingCart.items[0] && shoppingCart.items[0].weight) {
                        shoppingCart.total_weight = {
                            'value': '',
                            'unit': shoppingCart.items[0].weight.unit
                        };
                    } else {
                        shoppingCart.total_weight = {
                            'value': '',
                            'unit': 'lbs'
                        };
                    }
                }
                return shoppingCartModel.action('updateShoppingcart', {
                    data: {
                        id: shoppingCart.id,
                        request: shoppingCart
                    },
                    success: function success(result) {
                        _angular.$timeout.cancel(_this.timer);
                        setAdditionalParameters(result);
                    }
                }).then(function () {
                    return calculateShippingCharges();
                });
            };

            callDeleteCart = function callDeleteCart(shoppingCart) {
                return shoppingCartModel.action('deleteShoppingcart', {
                    data: {
                        id: shoppingCart.id
                    }
                });
            };

            return buttonParamsModel.retrieve({
                params: {
                    raw_params: _squid.$meta.xclickParams
                },
                success: function success(resp) {
                    var payeeEmail = void 0,
                        visitorId = void 0,
                        shoppingUrl = void 0;
                    _underscore2['default'].forEach(resp, function (param) {
                        if (typeof param === 'string') {
                            var key = param.split('=')[0];
                            var value = param.split('=')[1];
                            if (key === 'merchant_email') {
                                payeeEmail = value;
                            } else if (key === 'merchant_acc_number') {
                                merchantAccNumber = value;
                            } else if (key === 'visitor_id') {
                                visitorId = value;
                            }
                        }
                    });
                    shoppingUrl = _customUtil.customUtil.decodeAndParse(_squid.$meta.xclickParams)['shopping_url'];
                    if (!visitorId) {
                        if (buttonType === 'view_cart') {
                            _logger.$logger.info('cart_empty');
                            _this.stateChanged = true;
                            _this.continueShoppingUrl = shoppingUrl || _this.previousPageUrl;
                            _angular.$rootScope.continueShoppingUrl = _this.continueShoppingUrl;
                            return _uiRouter.$state.go('checkout.emptyCart');
                        } else {
                            _logger.$logger.info('cart_empty_create_cart');
                            return createShoppingCart(buttonParams.buttonItem, payeeEmail, visitorId);
                        }
                    }
                    shoppingCartModel.invalidate();
                    return _angular.$q.all([shoppingCartModel.retrieve({
                        params: {
                            payee_email: payeeEmail,
                            visitor_id: visitorId
                        },
                        success: function success(response) {
                            if (buttonType === undefined) {
                                // when the button item has neither add nor display parameter
                                _logger.$logger.info('NO_ADD_OR_DISPLAY');
                                return _angular.$q.reject('NO_ADD_OR_DISPLAY');
                            }
                            if (response.resourceNotFound) {
                                if (buttonType === 'view_cart') {
                                    _logger.$logger.info('cart_empty');
                                    _this.stateChanged = true;
                                    _this.continueShoppingUrl = shoppingUrl || _this.previousPageUrl;
                                    _angular.$rootScope.continueShoppingUrl = _this.continueShoppingUrl;
                                    shoppingCartModel.redirect = {
                                        state: 'checkout.emptyCart'
                                    };
                                    return;
                                } else {
                                    _logger.$logger.info('cart_empty_create_cart');
                                    if (!_cartUtil2['default'].buttonItemHasPrice(buttonParams)) {
                                        // this could be because of item amount missing, empty or invalid
                                        _logger.$logger.info('ITEM_PRICE_MISSING');
                                        return _angular.$q.reject('ITEM_PRICE_MISSING');
                                    }
                                    return createShoppingCart(buttonParams.buttonItem, payeeEmail, visitorId);
                                }
                            } else {
                                sCart = $.extend(true, {}, response);
                                _this.itemsInCart = $.extend(true, [], response.items);
                                cartItems = $.extend(true, [], response.items);
                                _this.currencyCode = response.items && response.items[0] && response.items[0].currency;
                                _this.continueShoppingUrl = response.urls && response.urls.shopping_url || _this.previousPageUrl;
                                if (buttonType === 'add_to_cart' && noUpdateRequired !== 'true') {
                                    _logger.$logger.info('cart_exists_update_cart');
                                    if (!_cartUtil2['default'].buttonItemHasPrice(buttonParams)) {
                                        // this could be because of item amount missing, empty or invalid
                                        _logger.$logger.info('ITEM_PRICE_MISSING');
                                        return _angular.$q.reject('ITEM_PRICE_MISSING');
                                    }
                                    var shoppingcartToUpdate = _cartUtil2['default'].addItemToCart(buttonParams.buttonItem, response);
                                    _this.cartStateChanged = true;
                                    return callUpdateCart(shoppingcartToUpdate);
                                } else {
                                    setAdditionalParameters(response);
                                    _logger.$logger.info('cart_exists_show_cart');
                                }
                            }
                        },
                        contingencies: {
                            INVALID_INPUT: function INVALID_INPUT(err) {
                                _logger.$logger.info('shopping_cart_error', err.name);
                                return _angular.$q.reject('INVALID_INPUT');
                            },
                            DEFAULT: function DEFAULT(err) {
                                _logger.$logger.info('shopping_cart_error', err.name);
                                return _angular.$q.reject('DEFAULT');
                            }
                        }
                    })]).then(function (res) {
                        if (res && res[0] && res[0].redirect) {
                            return _uiRouter.$state.go(res[0].redirect.state);
                        } else if (_this.duplicateRequest) {
                            return getShoppingCart();
                        } else {
                            return calculateShippingCharges();
                        }
                    }).then(function (res) {
                        if (buttonType === 'add_to_cart') {
                            return consumeMid();
                        }
                    })['catch'](function (error) {
                        if (genericErrorCases.indexOf(error) > -1) {
                            return _uiRouter.$state.go('checkout.error.genericError');
                        } else {
                            return fallback('wps', 'shoppingcart_checkout_fallback');
                        }
                    });
                },
                contingencies: {
                    INVALID_MERCHANT_EMAIL: function INVALID_MERCHANT_EMAIL(errorName) {
                        _logger.$logger.info('ppcart_mapper_get_xclick_params_error', errorName);
                        return _uiRouter.$state.go('checkout.error.genericError');
                    }
                }
            });
        }
    },

    actions: {
        continueShopping: function continueShopping($event) {
            if ($event) {
                $event.preventDefault();
            }

            // TODO: add a util function to do this logic which is in multiple pages now
            if (window.opener && !window.opener.closed) {
                _logger.$logger.info('continue_shopping_target_not_self');
                try {
                    window.opener.location.href = this.continueShoppingUrl;
                } catch (err) {
                    _logger.$logger.info('window_opener_location_error', { err: err });
                } finally {
                    self.close();
                }
            } else {
                _logger.$logger.info('continue_shopping_target_self');
                _squid.$util.redirect(this.continueShoppingUrl);
            }
        },
        increment: function increment(index) {
            this.itemsInCart[index].quantity++;
            cartItems[index].quantity = this.itemsInCart[index].quantity;
            this.cartStateChanged = true;
            initiateUpdateQuantity();
        },
        decrement: function decrement(index) {
            if (this.itemsInCart[index].quantity > 0) {
                this.itemsInCart[index].quantity--;
                cartItems[index].quantity = this.itemsInCart[index].quantity;
                this.cartStateChanged = true;
                initiateUpdateQuantity();
            }
        },
        remove: function remove(index) {
            var _this2 = this;

            this.itemsInCart[index].removed = true;
            cartItems[index].removed = true;
            if (this.currentExpandedDetails === index) {
                this.currentExpandedDetails = undefined;
            }
            var cart = $.extend(true, {}, sCart);
            _cartUiUtil2['default'].setOrderSummaryColor();
            cart.items = itemsToUpdate();
            if (cart.items.length === 0) {
                _logger.$logger.info('all_items_removed');
                this.cartStateChanged = false;
                _angular.$q.all([callDeleteCart(cart)]).then(function () {
                    _this2.stateChanged = true;
                    _angular.$rootScope.continueShoppingUrl = _this2.continueShoppingUrl;
                    return _uiRouter.$state.go('checkout.emptyCart');
                });
            } else {
                this.cartStateChanged = true;
                (0, _angular.$timeout)(function () {
                    _angular.$q.all([callUpdateCart(cart)]).then(function () {
                        $('#shoppingCart').focus();
                        return;
                    });
                }, 500);
            }
        },
        updateItemAmount: function updateItemAmount(index) {
            var value = +$('input#itemTotalInput' + index).val();
            if (value && this.itemsInCart[index].quantity > 0) {
                this.itemsInCart[index].price = +(value / this.itemsInCart[index].quantity).toFixed(2);
                var cart = $.extend(true, {}, sCart);
                cart.items[index].price = this.itemsInCart[index].price;
                this.cartStateChanged = true;
                callUpdateCart(cart);
            }
        },
        keyUp: function keyUp(event, index) {
            event = event || window.event;
            if (event) {
                // 38 : up arrow, 40: down arrow
                if (event.keyCode === 38) {
                    this.actions.increment(index);
                } else if (event.keyCode === 40) {
                    this.actions.decrement(index);
                }
            }
        },
        checkValidity: function checkValidity(index, oldValue) {
            // allow user to enter only a positive integer
            if (!/^\d*$/.test(this.itemsInCart[index].quantity)) {
                cartItems[index].quantity = this.itemsInCart[index].quantity = oldValue;
            } else if (this.itemsInCart[index].quantity !== '') {
                this.cartStateChanged = true;
            } else {
                this.cartStateChanged = false;
            }
        },
        showMore: function showMore(index) {
            var _this3 = this;

            var delay = 0;

            if (this.currentExpandedDetails !== index) {
                if (this.currentExpandedDetails !== undefined) {
                    delay = 500;
                    this.actions.showLess(this.currentExpandedDetails);
                }
            }

            (0, _angular.$timeout)(function () {
                if (_this3.itemsInCart[index]) {
                    _this3.itemsInCart[index].showDetails = true;
                    _this3.itemsInCart[index].showExtraText = true;
                    $('#item' + index + 'properties').focus();
                } else {
                    _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: _this3.itemsInCart && _this3.itemsInCart.length });
                }
                angular.element('#item' + index + 'name').removeClass('ellipsisEffect');
                angular.element('#item' + index + 'number').removeClass('ellipsisEffect');
                if (angular.element('#item' + index + 'name').hasClass('nowrap')) {
                    angular.element('#item' + index + 'name').removeClass('nowrap');
                }
                if (angular.element('#item' + index + 'number').hasClass('nowrap')) {
                    angular.element('#item' + index + 'number').removeClass('nowrap');
                }
                if (angular.element('#item' + index + 'number').hasClass('hide')) {
                    angular.element('#item' + index + 'number').removeClass('hide');
                }

                _this3.currentExpandedDetails = index;
            }, delay);
        },
        showLess: function showLess(index) {
            if (this.itemsInCart[index]) {
                this.itemsInCart[index].showDetails = false;
                this.itemsInCart[index].showExtraText = false;
                $('#item' + index + 'properties > a:nth-child(4)').focus();
            } else {
                _logger.$logger.info('Cannot showMore of item: ', { index: index, itemsCount: this.itemsInCart && this.itemsInCart.length });
            }
            angular.element('#item' + index + 'name').addClass('ellipsisEffect');
            angular.element('#item' + index + 'number').addClass('ellipsisEffect');
            if (this.itemsInCart[index].itemNameLong) {
                angular.element('#item' + index + 'number').addClass('hide');
            }
            (0, _angular.$timeout)(function () {
                angular.element('#item' + index + 'name').addClass('nowrap');
                angular.element('#item' + index + 'number').addClass('nowrap');
            }, 500); // same time duration specified in max-height transition
            this.currentExpandedDetails = undefined;
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this4 = this;

            var loadJsButton = function loadJsButton(checkoutType, localeInfo) {
                var script = document.createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.setAttribute('data-merchant', 'PP_ADD_TO_CART');
                script.setAttribute('data-button', 'checkout');
                script.setAttribute('data-type', 'button');
                script.setAttribute('data-size', 'medium');
                script.setAttribute('data-lc', localeInfo);
                script.setAttribute('data-shape', 'pill');
                if (checkoutType === 'member') {
                    script.setAttribute('data-color', 'gold');
                } else {
                    script.setAttribute('data-color', 'silver');
                    script.setAttribute('data-label', _squid.$locale.content.get('shoppingCart.checkoutOut'));
                    script.setAttribute('data-tagline', 'false');
                }
                script.src = 'https://www.paypalobjects.com/api/button.js';
                return script;
            };

            this.cartTotalZero = false;

            fallback = function fallback(product, reason) {
                throw new _squid.$FallbackError({
                    product: product,
                    reason: reason
                });
            };

            angular.element('.merchantHeader').removeClass('showMerchantHeader');
            var localeInfo = _squid.$locale.lang + '_' + _squid.$locale.country;
            _logger.$logger.info('localeInfo', { country: _squid.$locale.country, lang: _squid.$locale.lang });

            memberXOButtonScript = loadJsButton('member', localeInfo);
            guestXOButtonScript = loadJsButton('guest', localeInfo);

            buttonParams = _cartUtil2['default'].getButtonParams(_squid.$meta.xclickParams);
            this.previousPageUrl = document.referrer;

            this.getCartItemsTotal = function () {
                return _cartUtil2['default'].getCartItemsTotal(_this4.itemsInCart);
            };

            this.getNetTotal = function () {
                var sum = _this4.getCartItemsTotal() || 0;
                _underscore2['default'].forEach(_this4.additionalCharges, function (detail) {
                    if (detail.name === 'discount') {
                        sum -= detail.value;
                    } else {
                        sum += detail.value;
                    }
                });
                return sum;
            };

            this.toggleArrowDirection = function () {
                _this4.expandSummary = !_this4.expandSummary;
                if (_this4.expandSummary) {
                    _this4.orderSummaryMaxHeight = $('.details-expand').prop('scrollHeight');
                }
                $('#orderSummary').attr('aria-expanded', _this4.expandSummary);
                (0, _angular.$timeout)(function () {
                    _cartUiUtil2['default'].setOrderSummaryColor();
                }, 500);
            };

            this.getEachItemMaxHeight = function (index) {
                return _cartUiUtil2['default'].getEachItemMaxHeight(_this4.itemsInCart, index);
            };

            this.getItemsMaxHeight = function (index) {
                return _cartUiUtil2['default'].getItemsMaxHeight(_this4.itemsInCart, index, _this4.scrolledToEnd);
            };

            this.getDetailsMaxHeight = function (index) {
                return _cartUiUtil2['default'].getDetailsMaxHeight(index);
            };

            this.getItemNameMaxHeight = function (index) {
                return _cartUiUtil2['default'].getItemNameMaxHeight(index);
            };

            this.tooLong = function (index, field) {
                if (field === 'name') {
                    _this4.itemsInCart[index].itemNameLong = true;
                } else if (field === 'number') {
                    _this4.itemsInCart[index].itemNumberLong = true;
                }
            };

            this.getContainerColWidth = function () {
                return _cartUiUtil2['default'].getContainerColWidth();
            };
        },
        populate: function populate() {
            var _this5 = this;

            if (this.stateChanged) {
                return;
            }
            $('#wrapper').addClass('cartBody');
            this.$on('$destroy', function () {
                $('#wrapper').removeClass('cartBody');
            });
            var memberCheckoutElement = document.getElementById('memberCheckout');
            var guestCheckoutElement = document.getElementById('guestCheckout');
            if (memberCheckoutElement) {
                memberCheckoutElement.appendChild(memberXOButtonScript);
            }
            if (guestCheckoutElement) {
                guestCheckoutElement.appendChild(guestXOButtonScript);
            }

            var buttonItemDetails = buttonParams && buttonParams.buttonItem;
            var merchantDetails = _cartUtil2['default'].getMerchantDetails(sCart, buttonItemDetails);
            _angular.$rootScope.$broadcast('merchantDetails', merchantDetails);

            _cartUiUtil2['default'].initWindowScrollActions();
            this.areAllItemsVisible = _cartUiUtil2['default'].areAllItemsVisible();
            _cartUiUtil2['default'].setOrderSummaryColor();
            this.expandSummary = this.itemsInCart && this.itemsInCart.length < 4;
            if (this.itemsInCart && this.itemsInCart.length >= 4 && !this.areAllItemsVisible) {
                $('#orderSummary').css('transform', 'translateY(' + Number($('.footer').prop('scrollHeight') + 1) + 'px)');
            }
            $('#orderSummary').attr('aria-expanded', this.expandSummary);

            // To detect JS checkout button load, watch for change in contents of div#guestCheckout.
            // The child element in initially a <script>. When the script loads, executes and renders the button, the child element would be a <span>.
            var watchJSButton = this.$watch(function () {
                return $('#guestCheckout').children().get(0) && $('#guestCheckout').children().get(0).nodeName;
            }, function (newValue, oldValue) {
                if (newValue !== oldValue && newValue === 'SPAN') {
                    // the javascript guest checkout button is now loaded
                    var guestXOButton = $('#guestCheckout > span > button');
                    if (guestXOButton) {
                        guestXOButton.attr('aria-describedby', 'payWithoutAccountMsg');
                    }
                    // add alt='' to <img> elements inside the buttons which have no alt text
                    var imgElements = $('.checkoutButtons img');
                    imgElements.attr('alt', function (index, value) {
                        return value ? value : '';
                    });
                    clearWatch();
                }
            });

            function clearWatch() {
                watchJSButton();
            }

            var itemsElement = document.getElementById('items');
            var scrollTopLimit = 999999;
            var scrolled = function scrolled() {
                if (_this5.itemsInCart && _this5.itemsInCart.length < 4) {
                    return;
                }
                // visible height + pixel scrolled = total height
                if (itemsElement.offsetHeight + itemsElement.scrollTop === itemsElement.scrollHeight) {
                    scrollTopLimit = itemsElement.scrollTop;
                    _this5.scrolledToEnd = true;
                    $('#orderSummary').removeClass('pushDown');
                    $('#orderSummary').css('transform', 'translateY(0)');
                    _this5.getItemsMaxHeight();
                } else if (itemsElement.scrollTop <= scrollTopLimit) {
                    _this5.scrolledToEnd = false;
                    $('#orderSummary').addClass('pushDown');
                    $('#orderSummary').css('transform', 'translateY(' + Number($('.footer').prop('scrollHeight') + 1) + 'px)');
                    _this5.getItemsMaxHeight();
                }
            };
            if (itemsElement) {
                itemsElement.onscroll = scrolled;
            }
            if (this.itemsInCart && this.itemsInCart.length < 4) {
                this.scrolledToEnd = true;
            }
            initiateUpdateQuantity = function initiateUpdateQuantity() {
                if (_this5.timer) {
                    _angular.$timeout.cancel(_this5.timer);
                }
                _this5.timer = (0, _angular.$timeout)(function () {
                    var cart = $.extend(true, {}, sCart);
                    cart.items = itemsToUpdate();
                    callUpdateCart(cart);
                }, 1000);
            };

            this.initiateUpdateQuantity = function (index) {
                cartItems[index].quantity = _this5.itemsInCart[index].quantity;
                initiateUpdateQuantity();
            };

            itemsToUpdate = function itemsToUpdate() {
                var items = [];
                _underscore2['default'].forEach(cartItems, function (item) {
                    if (!item.removed) {
                        if (item.quantity === '') {
                            item.quantity = 1;
                        }
                        items.push(item);
                    }
                });
                return items;
            };

            var insertXclickParamsInMayfly = function insertXclickParamsInMayfly() {
                checkoutXclickParam = _cartUtil2['default'].getParamsForCheckout(_squid.$meta.xclickParams);
                return _index.$ShoppingCartModel.instance(_squid.$meta.correlationId).action('insertMayflyData', {
                    data: checkoutXclickParam,
                    success: function success(result) {
                        return result && result.mayflyId;
                    },
                    error: function error(err) {
                        _logger.$logger.info('Insert_MayFly_Error', err.name);
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(errorName) {
                            _logger.$logger.info('Insert_MayFly_Error', errorName);
                        }
                    }
                });
            };

            var createSymphonyCartRequest = function createSymphonyCartRequest() {
                _cartUtil2['default'].removeHashKey(sCart);
                return _index2.$PPCartMapperModel.instance().action('getCartRequest', {
                    data: {
                        request: sCart,
                        flowLoggingId: _squid.$util.param('flowlogging_id'),
                        merchantAccNumber: merchantAccNumber
                    },
                    success: function success(result) {
                        cartRequest = result;
                    },
                    error: function error(err) {
                        _logger.$logger.info('error', err.name);
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    },
                    contingencies: {
                        INVALID_HOSTED_BUTTON_ID: function INVALID_HOSTED_BUTTON_ID() {
                            _logger.$logger.info('ppcart_mapper_get_cart_request_error', 'INVALID_HOSTED_BUTTON_ID');
                            return _angular.$q.reject('INVALID_HOSTED_BUTTON_ID');
                        },
                        DEFAULT: function DEFAULT(errorName) {
                            _logger.$logger.info('ppcart_mapper_get_cart_request_error', errorName);
                            return _angular.$q.reject('DEFAULT');
                        }
                    }
                });
            };

            var handleInvalidAddressContingency = function handleInvalidAddressContingency() {
                return _uiRouter.$state.go('checkout.error.invalidAddressError', {
                    code: addressErrorData.name,
                    data: addressErrorData.details && addressErrorData.details.errorFields
                });
            };

            var createSymphonyCart = function createSymphonyCart() {
                var cart = cartRequest;

                return _index2.$PPCartMapperModel.instance().action('createCart', {
                    data: {
                        request: cart,
                        flowLoggingId: _squid.$util.param('flowlogging_id'),
                        merchantAccNumber: merchantAccNumber
                    },
                    success: function success(result) {
                        checkoutCartDetails = result;
                        _logger.$logger.info('checkoutCartId', checkoutCartDetails.cartId);
                    },
                    error: function error(err) {
                        _logger.$logger.info('error', err.name);
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    },
                    contingencies: {
                        PAYEE_ACCOUNT_RESTRICTED: function PAYEE_ACCOUNT_RESTRICTED(err) {
                            _logger.$logger.info('ppcart_mapper_create_cart_error', err);
                            return _angular.$q.reject('PAYEE_ACCOUNT_RESTRICTED');
                        },
                        INTERNAL_SERVICE_ERROR: function INTERNAL_SERVICE_ERROR(err) {
                            _logger.$logger.info('ppcart_mapper_create_cart_error', err);
                            return _angular.$q.reject('INTERNAL_SERVICE_ERROR');
                        },
                        DEFAULT: function DEFAULT(errorName) {
                            _logger.$logger.info('ppcart_mapper_create_cart_error', errorName);
                            return _angular.$q.reject('DEFAULT');
                        },
                        ADDRESS_ERROR: function ADDRESS_ERROR(name, data) {
                            addressError = true;
                            addressErrorData = {
                                name: name,
                                details: data
                            };
                            _logger.$logger.info('ppcart_mapper_create_cart_error_address_error', name);
                            _logger.$logger.info('ppcart_mapper_create_cart_error_address_error_data', data);
                        }
                    }
                });
            };

            var checkInventory = function checkInventory() {
                var shoppingCart = cartRequest && cartRequest.cart;
                var purchaseUnit = shoppingCart && shoppingCart.purchase_units && shoppingCart.purchase_units[0];
                var items = purchaseUnit && purchaseUnit.item_list && purchaseUnit.item_list.items;
                var inventoryModel = _index4.$InventoryModel.instance(_squid.$meta.correlationId);
                return inventoryModel.action('getInventory', {
                    data: {
                        items: items,
                        merchantId: buttonParams.merchantId
                    },
                    success: function success(result) {
                        soldoutItems = undefined;
                        var isInventory = result.isInventory ? 1 : 0;
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'shoppingCart',
                            'to': 'check_inventory',
                            'is_inventory_enabled': isInventory
                        });
                        if (result.soldoutItems && result.soldoutItems.length > 0) {
                            soldoutItems = result.soldoutItems;
                            _angular.$rootScope.soldoutUrl = result.soldoutUrl;
                        }
                    },
                    error: function error(err) {
                        _logger.$logger.info('error', err.name);
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'shoppingCart',
                            'to': 'process_cart_creation',
                            'int_error_description': 'invetory_error',
                            'reason': 'CART_CREATION_FAILURE'
                        });
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    },
                    contingencies: {
                        DEFAULT: function DEFAULT(name, err) {
                            _logger.$logger.info('error', err.name);
                            _logger.$logger.info('checkout_fpti', {
                                'from': 'shoppingCart',
                                'to': 'process_cart_creation',
                                'int_error_description': 'invetory_error',
                                'reason': 'CART_CREATION_FAILURE'
                            });
                            return fallback('wps', 'shoppingcart_checkout_fallback');
                        }
                    }
                });
            };

            prepareCheckout = function prepareCheckout(flow) {

                var redirectUrl = void 0;
                if (flow === 'member') {
                    _logger.$logger.info('checkout_type_member');
                    redirectUrl = _squid.$config.urls.hermesUrl;
                } else {
                    if (!_squid.$config.guestCheckoutEnabled) {
                        _logger.$logger.info('checkout_fpti', {
                            'from': 'shoppingCart',
                            'to': 'prepare_guest_checkout',
                            'int_error_description': 'guest_checkout_disabled',
                            'reason': 'GUEST_CHECKOUT_DISABLED'
                        });
                        return fallback('wps', 'shoppingcart_checkout_fallback');
                    }
                    _logger.$logger.info('checkout_type_guest');
                    redirectUrl = _squid.$config.urls.xoonUrl;
                }
                var cart = $.extend(true, {}, sCart);
                cart.items = _cartUtil2['default'].getItemsForCheckout(cartItems);
                if (cart.items.length !== sCart.items.length) {
                    _this5.cartStateChanged = true;
                }
                if (cart.items.length === 0) {
                    _logger.$logger.info('cart_empty');
                    _this5.cartStateChanged = false;
                    return _angular.$q.all([callDeleteCart(cart)]).then(function () {
                        _this5.stateChanged = true;
                        _angular.$rootScope.continueShoppingUrl = _this5.continueShoppingUrl;
                        return _uiRouter.$state.go('checkout.emptyCart');
                    });
                } else {
                    return _angular.$q.all([callUpdateCart(cart)]).then(function () {
                        return createSymphonyCartRequest();
                    }).then(function () {
                        return checkInventory();
                    }).then(function () {
                        if (!soldoutItems) {
                            return createSymphonyCart();
                        }
                        return _angular.$q.when();
                    }).then(function () {
                        if (!soldoutItems) {
                            return insertXclickParamsInMayfly();
                        }
                        return _angular.$q.when();
                    }).then(function (mayflyId) {
                        if (soldoutItems) {
                            _logger.$logger.info('item(s)_sold_out');
                            var itemsSoldout = void 0,
                                count = void 0;
                            if ((typeof soldoutItems === 'undefined' ? 'undefined' : _typeof(soldoutItems)) === 'object') {
                                itemsSoldout = JSON.stringify(soldoutItems);
                                count = _this5.itemsInCart.length === soldoutItems.length ? 'all' : 'many';
                            } else {
                                itemsSoldout = soldoutItems;
                                count = 'one';
                            }
                            _this5.stateChanged = true;
                            return _uiRouter.$state.go('checkout.soldout', {
                                items: encodeURIComponent(itemsSoldout),
                                count: encodeURIComponent(count)
                            });
                        } else if (addressError) {
                            _logger.$logger.info('address_error');
                            return handleInvalidAddressContingency();
                        } else {
                            _logger.$logger.info('item(s)_available');
                            redirectUrl += checkoutCartDetails.cartId;
                            if (checkoutCartDetails.rm) {
                                redirectUrl += '&rm=' + ('' + checkoutCartDetails.rm);
                            }
                            if (mayflyId) {
                                redirectUrl += '&mfid=' + ('' + mayflyId);
                            }
                            redirectUrl += '&country.x=' + ('' + _squid.$locale.country);
                            redirectUrl += '&locale.x=' + (_squid.$locale.lang + '_' + _squid.$locale.country);
                            _squid.$util.redirect(redirectUrl);
                        }
                    })['catch'](function (error) {
                        if (genericErrorCases.indexOf(error) > -1) {
                            return _uiRouter.$state.go('checkout.error.genericError');
                        } else {
                            return fallback('wps', 'shoppingcart_checkout_fallback');
                        }
                    });
                }
            };

            this.prepareCheckout = function (flow) {
                prepareCheckout(flow);
            };
        },
        exit: function exit() {
            angular.element('.merchantHeader').addClass('showMerchantHeader');
            clearInterval(this.timer);
        }
    }
});


_angular.$timeout;

_angular.$q;

_angular.$rootScope;

_squid.$Component;

_squid.$config;

_squid.$util;

_squid.$meta;

_squid.$locale;

_squid.$FallbackError;

_uiRouter.$state;

_logger.$logger;

_index.$ShoppingCartModel;

_index2.$PPCartMapperModel;

_index3.$CartButtonParamsModel;

_index4.$InventoryModel;

_customUtil.customUtil;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shopping-cart/directive.js
// module id = ./pages/xo-shopping-cart/directive.js
// module chunks = 1